var _path, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConservative = function SvgConservative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 59,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "conservative_svg__a",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.64.12h116.38v57.151H.64z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "conservative_svg__b",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EEC0",
    stroke: "#C0EEC0",
    d: "m53.758 53.089 3.41-1.2L40.242 2.331l-18.338 8.977-10.633 13.899z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative_svg__c",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    stroke: "#92DE63",
    d: "M57.117 49.98 40.224.005 58.627-4.25l19.08 3.813-16.43 50.669z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative_svg__d",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    d: "M106.948 22.936 68.336 49.31l3.868 7.525h46.347l-3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative_svg__e",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 58.901,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#EFE",
    d: "M10.712 22.936 49.324 49.31l-3.868 7.525H-.892l3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative_svg__f",
    width: 118,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.83,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    d: "m65.194 51.686-3.429-1.143L77.866.711 96.35 9.383l10.862 13.72z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.829,
    cy: 58.907,
    r: 26.263,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m47.909 46.329 1.041-5.296 5.42 1.065M59.17 55.847l-9.367-13.583"
  })));
};
export { SvgConservative as ReactComponent };
export default __webpack_public_path__ + "images/conservative.svg";